import { createContext } from "react";

const LoadContext = createContext();

export default LoadContext;